import { React, useState, useEffect } from "react";
import {View, Text, Image, TouchableOpacity, Linking, TextInput, Pressable, ScrollView} from "react-native";
import {getAllVehiclesListApi, getPoolAccountdetail} from "../api/apiManager";
import ModalAlert from "../common/ModalAlert";
import { useDeviceSize} from "rn-responsive-styles";
import payment_logos from "../assets/images/payment_logos.png";
import applicationStyles from "../styles/applicationStyles";
import PaymentScreen from "./payment/PaymentScreen";
import CustomInput from "../common/CustomInput";
import * as RootNavigation from "../utilities/RootNavigation";
import { policyDetails } from "../api/tripInsurance";
import { isEmpty } from "lodash";
import useStyles from "./RechargeScreen_Styles";
import CImage from "../common/CImage";
import CQrCodeModal from "../common/CQrCodeModal";
import CHeader from "../common/CHeader";
import { getConfigurations } from "../api/serviceRequest"; 
const rechargePattern = /^[1-9][0-9]*(\.[0-9]{1,2}){0,1}$/;
export default function Recharge(props) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [selectedLayout, setSelectedLayout] = useState("Recharge");
  const [poolAcntNbr, setPoolAcntNbr] = useState("");
  const [policyData, setPolicyData] = useState({});
  const isSmallDevice = deviceSize === "small" || deviceSize === "extrasmall";
  const isTabView = deviceSize === "medium";
  const [HTMLDATA, setHTMLDATA] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [items, setItem] = useState([]);
  const [poolActBal, setPoolActBal] = useState(0);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState("");
  const [availableBalance, setAvailableBalance] = useState("Make selection");
  const [amount, setAmount] = useState("");
  const [isDropdownEditable, setDropdownEditable] = useState(true);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [qrModal, setQrModal] = useState(false);
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "", actionButton: "",});

  const onCloseModal = () => { setAlertModalVisible(false);};
  const qrcodeClcik = () =>{
    if(selectedItemDetails !== ""){
      setQrModal(true)
    }else{
      setAlertModal({
        title: "Error",
        status: "error",
        message: "Kindly select the valid vehicle.",
        actionButton: "OK",
      })
      setAlertModalVisible(true)
    }
  }
  const onCloseQrModal = () =>{
    setQrModal(false)
  }
  useEffect(()=>{
    loadDefaultConfig()
  },[])
  const loadDefaultConfig = () => {
    
    getConfigurations().then((res)=>{
      if(res.statusCode == 200) {

        const ccavenueAccessCode =res?.data.find((configItem) => configItem.key == "ccavenue_access_code_ff_portal");
        const CC_AVENUE_URL =res?.data.find((configItem) => configItem.key == "CC_AVENUE_URL");

        if (CC_AVENUE_URL) {
          global.CC_AVENUE_URL = CC_AVENUE_URL.value;
        }
        
        if (ccavenueAccessCode) {
          global.ccavenueAccessCode = ccavenueAccessCode.value;
        }
      }
    }).catch((err)=>{
      global.maxUploadFileSizeInMB = 2
      global.kycMaxUploadFileSizeInMB = 1
    })
}

  useEffect(() => {
    getPoolAccountDtls();
    getAllVehiclesList();
    getPolicyDetails();
  }, []);

  const toggleDropdown = () => setOpen(!isOpen);
  const getPoolAccountDtls = () => {
    getPoolAccountdetail()
      .then((res) => {
        setPoolAcntNbr(res?.accountNo || "");
        setPoolActBal(res?.accountBal || 0);
      }).catch((err) => {});
  };
  const handleItemClick = (item) => {
    setOpen(false);
    let vrn = item?.vrn
    setSelectedItem((prev) => (prev == vrn ? "" : vrn));
    setSelectedItemDetails(item)
  };
  const handlePoolAcntClick = (vrn) => {
    setOpen(false);
    setSelectedItemDetails("")
    setSelectedItem((prev) => (prev == vrn ? "" : vrn));
  };
  const getDropdownValue = () => {
    return selectedItem && selectedItem != "" && selectedItem != poolAcntNbr
      ? items.find((item) => item?.vrn === selectedItem)?.vrn : selectedItem == poolAcntNbr
      ? poolAcntNbr : "Choose Tag/Pool Acc";
  };

  useEffect(() => {
    if (selectedItem != "") {
      if (selectedItem == poolAcntNbr) {
        setAvailableBalance(poolActBal.toFixed(2));
        // setTagID("");
      } else {
        // setTagID(items.find((item) => item?.vrn === selectedItem)?.fastagId);
        setAvailableBalance(
          items
            .find((item) => item?.vrn === selectedItem)
            ?.fastagBalance.toFixed(2)
        );
      }}
  }, [selectedItem]);
  useEffect(() => {
    setSelectedItem([]);
    setAmount("");
    setAvailableBalance("");
  }, []);

  const getAllVehiclesList = () => {
    getAllVehiclesListApi()
      .then((res) => {
        if (res && !isEmpty(res)) {
          const rechargeNotAllowed = global?.recharge_not_allowed || []
          let temp  = res.filter((item) => {
            if(!rechargeNotAllowed?.includes(item.status)){return item}
            // if( item.status !== "Closed by NPCI"  && item.status !== "Blacklisted" && item.status !== "Blacklist" ){
            //   return item
            // }
            })
            setItem(temp);
        }
      }).catch((err) => {});
  };

  function amountChangeHandler(text) {
    /^$|^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/.test(text) ? setAmount(text) : setAmount((p) => p);
  }

  const getPolicyDetails = () => {
    policyDetails()
      .then((res) => {
        if (res?.statusCode == 1097) {setPolicyData(res?.data); }
      }).catch((err) => {});
  };

  const rechargeButtonPressHandler = () => {
    debugger
    let tagID = selectedItemDetails?.fastagId
    if(selectedItem == poolAcntNbr){
        tagID = ""
    }
    //changes to remove trip  insurance
    const tempObj = {
      ...props.data,
      rechargeAmount: amount, vrn: selectedItem, tagID: tagID, poolAcntNbr: poolAcntNbr,
    };
    props.setData({
      ...tempObj,
      ...{ insuranceSkipped: true },
      ...{ fromScreen: "Recharge" },
    });
    props.setScreen("PriceBreakup");
    return
    //-----to enable trip insurance , remove above code
    if (!global.showTripInsurance) {
      const tempObj = {
        ...props.data,
        rechargeAmount: amount, vrn: selectedItem, tagID: tagID,poolAcntNbr: poolAcntNbr,
      };
      props.setData({
        ...tempObj,
        ...{ insuranceSkipped: true },
        ...{ fromScreen: "Recharge" },
      });
      props.setScreen("PriceBreakup");
    } else {
      if (isEmpty(policyData) || policyData == "") {
        const tempObj = {
          ...props.data,
          rechargeAmount: amount, vrn: selectedItem, tagID: tagID, poolAcntNbr: poolAcntNbr,
        };
        props.setData({ ...tempObj, ...{ fromScreen: "" } });
        props.setScreen("Benifits");
      } else {
        const tempObj = {
          ...props.data,
          rechargeAmount: amount, vrn: selectedItem, tagID: tagID, poolAcntNbr: poolAcntNbr,
        };
        props.setData({
          ...tempObj,
          ...{ insuranceSkipped: true },
          ...{ fromScreen: "Recharge" },
        });
        props.setScreen("PriceBreakup");
      } }
  };


  return (
    <View style={styles.container}>
      <View style={styles.userDetailsViewStyle}></View>
      <View style={styles.paymentMethodInfoBar}>
        <View style={styles.paymentMethodIcons}> 
        <Image source={payment_logos} style={styles.InfoBarLogo} /> 
        </View>
        <View style={styles.InfoBarMessage}>
          {isTabView ? ( <Text style={[styles.InfoBarTitle, styles.infobarTitleTab]}> Now make quicker payments on the go with
          <Text style={styles.InfoBarTitleBold}> {" "}  FirstForward with support from all major UPI payment merchants </Text>  </Text> ) : isSmallDevice ? (
            <>
              <Text style={styles.InfoBarTitle}> Now make quicker payments on the go with</Text>
              <Text style={styles.InfoBarTitle}>FirstForward</Text>
              <Text style={styles.InfoBarTitle}> with support from all major UPI payment merchants </Text>
            </>
          ) : (
            <Text style={styles.InfoBarTitle}> Now make quicker payments on the go with <Text style={styles.InfoBarTitleBold}> FirstForward</Text> {"\n"}with support from all major UPI payment merchants</Text>
          )}
        </View>
      </View>

      {selectedLayout == "Payment Screen" ? ( <PaymentScreen screen={"Recharge"} paymentData={rechargeBody} />) : (
        <View style={styles.rechargeBody}>
                 <CHeader  disputeHeader title={"Recharge"} qrCode={true} qrcodeClcik = {qrcodeClcik}/>

          {isTabView ? (
            <>
              <View style={[styles.mr, styles.mrdd]}>
                <View style={[styles.mc1, styles.mc1dd]}>  
                <Text style={styles.dropdownLabel}>  Chassis/Vehicle No/{"\n"}Pool Account number  </Text>
                 </View>
                <View style={[styles.mc2, styles.mc2dd]}>
                  <View style={styles.dropDownViewStyle}>
                    <TouchableOpacity onPress={toggleDropdown} style={isOpen ? styles.dropdownHeader : styles.dropdownHeaderHide}>
                      <Text style={applicationStyles.dropDownHeaderText}> {getDropdownValue()}{" "} </Text>
                      <CImage.dropdownArrowBg />
                      </TouchableOpacity>
                    <View style={isOpen ? styles.showDropdown : styles.hideDropdown} >
                      <TouchableOpacity onPress={(e) => handlePoolAcntClick(poolAcntNbr)} style={applicationStyles.listItems}>
                        <Text style={applicationStyles.listItem}> Pool Account {poolAcntNbr} </Text>
                      </TouchableOpacity>
                      {items.map((item) => (<TouchableOpacity onPress={(e) => handleItemClick(item)} id={item.idNo} style={applicationStyles.listItems}>
                         <Text style={applicationStyles.listItem}> {item.label}{" "}</Text> 
                         </TouchableOpacity>))}
                    </View>
                  </View></View>
              </View>
              <View style={styles.mr}>
                <View style={styles.mc1}> 
                <Text style={styles.rbLabel}>Available Balance</Text>
                 </View>
                <View style={styles.mc2}> 
                <View style={styles.availBal}> 
                <Text style={selectedItem === "" ? styles.balAmtEmpty : styles.balAmt }> {availableBalance} </Text>
                </View></View>
              </View>
              <View style={styles.mr}>
                <View style={styles.mc1}>
                   <Text style={styles.rbLabel}>Amount</Text> 
                   </View>
                <View style={styles.mc2}>
                  <TextInput style={styles.amtBox} onChangeText={(e) => amountChangeHandler(e)} value={amount} placeHolder="Enter Amount" keyboardType="numeric" />
                </View>
              </View>
              <View style={styles.mr}>
                <View style={styles.mc1} />
                <View style={styles.mc2}>
                  <View style={styles.quickAddLabel}>
                     <Text style={styles.rbLabelSmall}>Tap quick add</Text>
                      </View>
                  <View style={styles.quickAddButtons}>
                    <Pressable style={styles.quickAddButton} onPress={() => setAmount(500)}> <Text style={styles.qabInnerText}>500</Text></Pressable>
                    <Pressable style={styles.quickAddButton} onPress={() => setAmount(1000)}> <Text style={styles.qabInnerText}>1000</Text> </Pressable>
                    <Pressable style={styles.quickAddButton} onPress={() => setAmount(1500)}> <Text style={styles.qabInnerText}>1500</Text> </Pressable>
                  </View></View>
              </View>
              <View style={styles.mr}>
                <View style={styles.mc1} />
                <View style={styles.mc2}>
                  <View style={styles.rbm}> 
                  <TouchableOpacity style={styles.rechargeButton} onPress={() => rechargeButtonPressHandler()}>
                    <Text style={styles.rechargeButtonInnerText}>{'Recharge'} </Text>
                    </TouchableOpacity>
                     </View>
                </View>
              </View>
              <View style={styles.r5}>
                <View style={styles.linkbox}>
                 <CImage.chainLinkIcon />
                  <Text style={styles.chainLabel}>Quick Links</Text>
                </View>
                <View style={styles.linkSet}>
                  <TouchableOpacity onPress={(e) => {setSelectedItem(poolAcntNbr); }}> 
                  <Text style={styles.oneLink}>Recharge Pool Account </Text> 
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => { RootNavigation.navigate("Statement"); global.activeScreen = "Statement";}}>
                     <Text style={styles.oneLink}> {"Pool Account Statement"} </Text> 
                     </TouchableOpacity>
                </View>
                 <View style={styles.linkSet}>
                  <TouchableOpacity onPress={() => {RootNavigation.navigate("Profile/PoolAccount/ChangeManual"); global.activeScreen = "Profile"}}> 
                  <Text style={styles.oneLink}> {"Change Pool Account Type"}</Text> 
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => {RootNavigation.navigate("Help"); global.activeScreen = "Help"; }}>
                     <Text style={styles.oneLink}>{"FAQ"}</Text>
                  </TouchableOpacity>
                </View>
                <View style={{ width: "5%" }} />
              </View>
            </>
          ) : isSmallDevice ? (
            <>
              <View style={[styles.sr, { position: "relative", zIndex: 9999 }]}>
                <Text style={[styles.rbLabel, styles.rbLabels]}> {'Chassis/Vehicle No/Pool Acc. No.'}</Text>
                <View style={[styles.dropDownViewStyles]}>
                  <TouchableOpacity onPress={toggleDropdown} style={ isOpen ? styles.dropdownHeader : styles.dropdownHeaderHide }>
                    <Text style={applicationStyles.dropDownHeaderText}> {getDropdownValue()}{" "}</Text>
                    <CImage.dropdownArrowBg />
                    </TouchableOpacity>
                  <View style={isOpen ? styles.showDropdown : styles.hideDropdown}>
                    <TouchableOpacity onPress={(e) => handlePoolAcntClick(poolAcntNbr)} style={applicationStyles.listItems}> 
                    <Text style={applicationStyles.listItem}>  Pool Account {poolAcntNbr} </Text> 
                    </TouchableOpacity>
                    {items.map((item) => ( <TouchableOpacity onPress={(e) => handleItemClick(item)} id={item.vrn} style={applicationStyles.listItems} > 
                    <Text style={applicationStyles.listItem}> {item.vrn}{" "} </Text> 
                    </TouchableOpacity> ))}
                  </View>
                </View>
              </View>
              <View style={styles.sr}>
                <Text style={[styles.rbLabel, styles.rbLabels]}> {'Available Balance'} </Text>
                <View style={[styles.availBal, styles.availBals]}>
                  <Text style={selectedItem === "" ? styles.balAmtEmpty : styles.balAmt}> {availableBalance} </Text>
                  </View>
              </View>
              <View style={styles.sr}>
                <Text style={[styles.rbLabel, styles.rbLabels]}>{'Amount'}</Text>
                <TextInput style={[styles.amtBox, styles.amtBoxs]} onChangeText={(e) => amountChangeHandler(e)} value={amount} placeHolder="Enter Amount" keyboardType="numeric" />
              </View>
              <View style={styles.sr}>
                <Text style={[styles.quickAddLabel, styles.qabls]}> {'Tap quick add'} </Text>
                <View style={[styles.quickAddButtons, styles.quickAddButtonss]}>
                  <Pressable style={styles.qabs} onPress={() => setAmount(500)}><Text style={styles.qabInnerText}>500</Text></Pressable>
                  <Pressable style={styles.qabs} onPress={() => setAmount(1000)}><Text style={styles.qabInnerText}>1000</Text></Pressable>
                  <Pressable style={styles.qabs} onPress={() => setAmount(1500)} ><Text style={styles.qabInnerText}>1500</Text></Pressable>
                </View>
              </View>
              <View style={styles.sr}>
                {amount != "" && amount != 0 && rechargePattern.test(amount) ? (
                  <TouchableOpacity style={styles.rechargeButton} onPress={() => rechargeButtonPressHandler()}> 
                  <Text style={styles.rechargeButtonInnerText}>{'Recharge'}</Text>
                  </TouchableOpacity>) : (
                  <TouchableOpacity style={[applicationStyles.buttonContainerStyleDisable,{ width: 230, height: 40 }]}>
                     <Text style={styles.rechargeButtonInnerText}>Recharge</Text> 
                     </TouchableOpacity>)}
              </View>
              <View style={styles.r5s}></View>
            </> ) : (
            <>
              <View style={styles.r1}>
                <View style={styles.rbr1c1}>
                  <Text style={styles.dropdownLabel}> Chassis/Vehicle No/{"\n"}Pool Account number  </Text>
                  <View style={styles.dropDownViewStyle}>
                    <TouchableOpacity onPress={!isDropdownEditable ? null : toggleDropdown} style={ isOpen ? styles.dropdownHeader : styles.dropdownHeaderHide} >
                      <Text style={applicationStyles.dropDownHeaderText}> {getDropdownValue()}{" "} </Text>
                      <CImage.dropdownArrowBg />
                       </TouchableOpacity>
                    <View style={isOpen ? styles.showDropdown : styles.hideDropdown} >
                      <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={true}>
                        <TouchableOpacity onPress={(e) => handlePoolAcntClick(poolAcntNbr)} style={applicationStyles.listItems}>  
                        <Text style={applicationStyles.listItem}> Pool Account {poolAcntNbr}</Text>
                         </TouchableOpacity>
                        {items.map((item, index) => (<TouchableOpacity onPress={(e) => handleItemClick(item)} key={index} id={item.vrn} style={applicationStyles.listItems}> 
                        <Text style={applicationStyles.listItem}> {item.vrn}{" "}</Text> 
                        </TouchableOpacity>))}
                      </ScrollView>
                    </View>
                  </View>
                </View>
                <View style={styles.rbr1c2}>
                  <Text style={styles.rbLabel}>Available Balance</Text>
                  <View style={styles.availBal}> 
                   <Text style={selectedItem === "" ? styles.balAmtEmpty : styles.balAmt}> {availableBalance}</Text> 
                   </View>
                </View>
              </View>
              <View style={styles.r2}>
                <View style={{ width: "27%" }}>
                   <Text style={styles.rbLabel}>Amount</Text> 
                   </View>
                <View style={styles.inputWidget}>
                  <CustomInput
                    onValueChanged={(e) => amountChangeHandler(e)}
                    value={amount}
                    requiredEndText={true}
                    keyboardType="numeric"
                    pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                    errorMessage={"Enter Valid Recharge Amount"}
                    maxLength={10}
                  />
                </View>
              </View>
              <View style={styles.r3}>
                <View style={styles.rbr3c1}>
                  <Text style={styles.rbLabelSmall}>Tap quick add</Text>
                  <Pressable style={styles.quickAddButton} onPress={() => setAmount(500)}> 
                  <Text style={styles.qabInnerText}>500</Text> 
                  </Pressable>
                  <Pressable style={styles.quickAddButton} onPress={() => setAmount(1000)} >
                    <Text style={styles.qabInnerText}>1000</Text>
                    </Pressable>
                </View>
                <View style={styles.rbr3c2}>
                  <TouchableOpacity style={styles.quickAddButton} onPress={() => setAmount(1500)}>
                     <Text style={styles.qabInnerText}>1500</Text>
                     </TouchableOpacity>
                </View>
              </View>
              <View style={styles.r4}>
                {amount != "" && amount != 0 && rechargePattern.test(amount) ? (
                  <TouchableOpacity style={styles.rechargeButton} onPress={() => rechargeButtonPressHandler()}> 
                  <Text style={styles.rechargeButtonInnerText}>{'Recharge'}</Text>
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity style={[applicationStyles.buttonContainerStyleDisable,{ width: 230, height: 40 }]}> 
                  <Text style={styles.rechargeButtonInnerText}>{'Recharge'}</Text>
                   </TouchableOpacity>
                )}
              </View>
              <View style={styles.r5}>
                <View style={styles.linkbox}>
                <CImage.chainLinkIcon />
                   <Text style={styles.chainLabel}>Quick Links</Text>
                </View>
                <View style={styles.linkSet}>
                  <TouchableOpacity onPress={(e) => { setSelectedItem(poolAcntNbr); }}> 
                  <Text style={styles.oneLink}>{'Recharge Pool Account'} </Text> 
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => {RootNavigation.navigate("Statement");global.activeScreen = "Statement";}} >
                     <Text style={styles.oneLink}> {"Pool Account Statement"} </Text>
                    </TouchableOpacity>
                </View>
                <View style={styles.linkSet}>
                  <TouchableOpacity onPress={() => {RootNavigation.navigate( "Profile/PoolAccount/ChangeManual");global.activeScreen = "Profile";}}> 
                  <Text style={styles.oneLink}> {"Change Pool Account Type"} </Text> 
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => { RootNavigation.navigate("Help"); global.activeScreen = "Help";}} >  
                  <Text style={styles.oneLink}>{"FAQ"}</Text>
                   </TouchableOpacity>
                </View>
                <View style={{ width: "20%" }} />
              </View>
            </>
          )}
      <Text>
          {HTMLDATA && HTMLDATA != "" && (
            <View style={styles.overlayViewStyle}>
              <View style={styles.overlay}>
                <View style={styles.alertModalWrapper} >
                <CImage.iconSuccesIinlineModalBg style={applicationStyles.iconSuccesIinlineModal}/>
                 <Text style={[[applicationStyles.titleIinlineModal,{ paddingHorizontal: 30, textAlign: "center" }]]} >
                    You will be redirected to payment gateway Click OK to
                    proceed
                  </Text>
                  <View style={styles.footer}>
                    <TouchableOpacity
                      onPress={() => {
                        setHTMLDATA("");
                        Linking.openURL( `${global.CC_AVENUE_URL}${HTMLDATA}&access_code=${global.ccavenueAccessCode}`);
                      }}
                      style={applicationStyles.footerBtnIinlineModal}
                    >
                      <Text style={applicationStyles.footerLinkIinlineModal}>{" "} OK </Text>
                    </TouchableOpacity>
                  </View>
                </View> 
                </View>
            </View>
          )}
    </Text>
        </View>
      )}
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal}  />
        </View>
      )}
      {qrModal ? 
       <View style={styles.overlayViewStyle}>
        <CQrCodeModal data = {selectedItemDetails} onCloseModal={onCloseQrModal}/>
        </View>:<></>}
    </View>
  );
}



